function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const admin_bar = document.querySelector("#_admin_bar");
	if (!admin_bar || !admin_bar.dataset.ct || !admin_bar.dataset.id) {
		return;
	}
	const page_url = new URL(
		`/misc/admin_tools/${admin_bar.dataset.ct}/${admin_bar.dataset.id}/`,
		window.location.origin,
	);
	const main_related = admin_bar.dataset.main_related;
	const main_related_ctype = admin_bar.dataset.main_related_ctype;
	const show_report = admin_bar.dataset.report;
	if (main_related) {
		page_url.searchParams.append("mr", main_related);
	}
	if (main_related_ctype) {
		page_url.searchParams.append("mr_ct", main_related_ctype);
	}
	if (show_report) {
		page_url.searchParams.append("report", show_report);
	}

	fetch(page_url.toString(), {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.admin_bar) {
				admin_bar.outerHTML = data.admin_bar;
				document
					.querySelector("#_admin_bar_icon")
					.addEventListener("click", (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();
						document.querySelector("#admin_bar").classList.toggle("d-none");
					});
			}
			if (data.report_bar) {
				document.querySelector("#_report_bar").outerHTML = data.report_bar;
			}
		})
		.catch((error) => {
			console.warn(error);
		});
});
